import React from 'react'
import { useParams } from 'react-router'
import { useRegion } from '../../hooks/CompanyConfiguration/useRegion'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import RegionView from '../../components/version-4/viewForms/RegionView'
import { ROUTES } from '../../shared/constants'

function ViewRegion() {
  const { region, getRegion } = useRegion()
  const params = useParams()

  React.useEffect(() => {

    getRegion({ regionId: params.regionId })
  }, [params.regionId])

  return (
    <Layout heading="Region" heading2="Info" url1={ROUTES.REGION} none>
      {region ? (
        <HeaderTabLayout
          heading="Region"
          content={<RegionView region={region} />}
          view
          url={`/edit-region/${params.regionId}`}
        />
      ) : <Loader />}
    </Layout>
  )
}

export default ViewRegion
